<nav class='navbar navbar-expand-lg navbar-dark bg-blue d-flex flex-column' *ngIf="nav.visible">
  <div class="container">
    <div class="navbar-header p-0">
      <button (click)="toggleCollapse()" class="navbar-toggler navbar-toggler-right" type="button">
        <span [hidden]="collapse==true" class="fa fa-bars fa-lg"></span>
        <span [hidden]="collapse==false" class="fa fa-times fa-lg"></span>
      </button>
    </div>
    <div id="navbarNav" class='navbar-collapse collapse' [ngClass]="{ 'show': collapse  }">
      <div id="accordion">
        <span *ngFor="let navItem of menuItems">
          <app-nav-menu-item [Item]="navItem"></app-nav-menu-item>
        </span>
        <!--<div class="card">
          <div class="card-header">
            <a [routerLink]='["/"]' class="card-link" data-toggle="collapse">
              Property Search
            </a>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseRC">
              Recorded Land
            </a>
          </div>
          <div id="collapseRC" class="collapse" data-parent="#accordion">
            <div class="card-body">
              <a [routerLink]='["rec-name-search"]' class="nav-link sub-menu"> Name </a>
              <a [routerLink]='["rec-address-search"]' class="nav-link sub-menu"> Address </a>
              <a [routerLink]='["rec-date-search"]' class="nav-link sub-menu"> Date </a>
              <a [routerLink]='["rec-value-search"]' class="nav-link sub-menu"> Value </a>
              <a [routerLink]='["rec-bp-search"]' class="nav-link sub-menu"> Book & Page </a>
              <a [routerLink]='["rec-doc-search"]' class="nav-link sub-menu"> Document No. </a>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseRG">
              Registered Land
            </a>
          </div>
          <div id="collapseRG" class="collapse" data-parent="#accordion">
            <div class="card-body">
              <a [routerLink]='["reg-name-search"]' class="nav-link sub-menu"> Name </a>
              <a [routerLink]='["reg-address-search"]' class="nav-link sub-menu"> Address </a>
              <a [routerLink]='["reg-date-search"]' class="nav-link sub-menu"> Date </a>
              <a [routerLink]='["reg-certificate-search"]' class="nav-link sub-menu"> Certificate </a>
              <a [routerLink]='["reg-value-search"]' class="nav-link sub-menu"> Value </a>
              <a [routerLink]='["reg-document-no-search"]' class="nav-link sub-menu"> Document No. </a>
              <a [routerLink]='["reg-owner-search"]' class="nav-link sub-menu"> Owner </a>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseRCP">
              Recorded Land Plans
            </a>
          </div>
          <div id="collapseRCP" class="collapse" data-parent="#accordion">
            <div class="card-body">
              <a [routerLink]='["/property-search-result-pg"]' class="nav-link sub-menu" (click)='collapse()'> Name </a>
              <a [routerLink]='["/fetch-data"]' class="nav-link sub-menu" (click)='collapse()'> Address </a>
              <a [routerLink]='["/fetch-data"]' class="nav-link sub-menu" (click)='collapse()'> Book & Page </a>
              <a [routerLink]='["/fetch-data"]' class="nav-link sub-menu" (click)='collapse()'> Plan No. </a>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseRGP">
              Registered Land Plans
            </a>
          </div>
          <div id="collapseRGP" class="collapse" data-parent="#accordion">
            <div class="card-body">
              <a [routerLink]='["/fetch-data"]' class="nav-link sub-menu" (click)='collapse()'> Address </a>
              <a [routerLink]='["/fetch-data"]' class="nav-link sub-menu" (click)='collapse()'> Certificate </a>
              <a [routerLink]='["/fetch-data"]' class="nav-link sub-menu" (click)='collapse()'> Court Case No. </a>
              <a [routerLink]='["/fetch-data"]' class="nav-link sub-menu" (click)='collapse()'> Plan No. </a>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseUIdx">
              UnIndexed Records
            </a>
          </div>
          <div id="collapseUIdx" class="collapse" data-parent="#accordion">
            <div class="card-body">
              <h6> Unindexed Property </h6>
              <a [routerLink]='["/fetch-data"]' class="nav-link sub-menu" (click)='collapse()'> 1890-1940 </a>
              <a [routerLink]='["/fetch-data"]' class="nav-link sub-menu" (click)='collapse()'> 1941-1950 </a>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <a [routerLink]='["/"]' class="card-link" data-toggle="collapse">
              Search Help
            </a>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <a [routerLink]='["/"]' class="card-link" data-toggle="collapse">
              Visit South Essex Website
            </a>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</nav>


